import { Suspense, lazy } from 'react';
import LoadingScreen from '../components/loading-screen';

const Loadable = (Component) => (props) =>
    (
        <Suspense fallback={<LoadingScreen />}>
            <Component {...props} />
        </Suspense>
    );

export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));
export const PagePortalHome = Loadable(lazy(() => import('../pages/Portal/Home')));
export const PageTournamentsResults = Loadable(lazy(() => import('../pages/Tournaments/Results')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
